import { render, staticRenderFns } from "./WFooter.vue?vue&type=template&id=0135f300&scoped=true&"
import script from "./WFooter.vue?vue&type=script&lang=js&"
export * from "./WFooter.vue?vue&type=script&lang=js&"
import style0 from "./WFooter.vue?vue&type=style&index=0&id=0135f300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0135f300",
  null
  
)

export default component.exports